module.exports = __webpack_public_path__ + "img/historicalPlans.79a9a578.svg";